import { useSelector } from 'react-redux';
import { getX50Hash, getX50Number, getX50Rand, getX50Salt } from '../selectors';

export const useFairGame = () => ({
  number: useSelector(getX50Number),
  hash: useSelector(getX50Hash),
  salt: useSelector(getX50Salt),
  rand: useSelector(getX50Rand),
});
